import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { TaskCountActions } from './task-count.actions';
import * as TaskCountSelectors from './task-count.selectors';
import { TaskCounts, TaskCountType } from '@lyceo/shared/task-count/util';

@Injectable({
  providedIn: 'root',
})
export class TaskCountFacade {
  private readonly store: Store = inject(Store);

  public readonly error: Signal<string | null> = this.store.selectSignal(
    TaskCountSelectors.selectCountError,
  );

  public readonly loading: Signal<boolean> = this.store.selectSignal(
    TaskCountSelectors.selectCountLoading,
  );

  public readonly taskCounts: Signal<TaskCounts> = this.store.selectSignal(
    TaskCountSelectors.selectTaskCounts,
  );

  public readonly homeTaskToPlan: Signal<number> = this.store.selectSignal(
    TaskCountSelectors.selectTaskToPlan,
  );

  public getTaskCounts(): void {
    this.store.dispatch(TaskCountActions.getTaskCounts());
  }

  public taskCountClicked(taskCountType: TaskCountType): void {
    this.store.dispatch(TaskCountActions.taskCountClicked({ taskCountType }));
  }
}
